import { Typography } from "@material-ui/core";
import React, {FC} from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const THead = styled.thead`
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
  height: 48px;

`

const Td = styled.td`
  text-align: center;
  vertical-align: middle;
  @media (max-width: 600px) {
    p {
      margin: 13px 0;
    }
  }
`

type PropsType = {
  items: string[]
}

const TableHead:FC<PropsType> = ({items}) => {
  const { t } = useTranslation()

  return (
    <THead>
      <tr>
        {items.map((item, index) => (
          <Td key={index}>
            <Typography>{t(item)}</Typography>
          </Td>
        ))}
      </tr>
    </THead>
  )
}

export default TableHead
